class SyncError extends Error {
    constructor(message, failedKey) {
        super(message);
        this.failedKey = failedKey;
    }
}

module.exports = SyncError;
